<div [id]="uid" class="popup-wrap fixed full overflow-y-auto" [style.z-index]="meta.zIndex" [style.padding]="meta.padding">
  <div class="overlay" [style.background-color]="meta.overlay"></div>
  <div class="entity-card" [style]="getDefaultInnerStyle()">
    <div class="card-inner" [style.width]="getWidth()">
      <ng-template modal-content></ng-template>
    </div>
  </div>
</div>
